import { ChangeDetectionStrategy, Component, Injector, Input } from '@angular/core';
import { Color } from 'src/app/config/color';
import { Action, Stylable } from '../../base-types';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ButtonComponent {

  @Input() primary: boolean = false
  @Input() marginBefore: string = '0';
  @Input() marginAfter: string = '0';

  @Input() set label(label: string){ this._label = label; }
  get label(): string{ return this._label }
  protected _label: string = 'BUTTON'

  @Input() set icon(icon: string){ this._icon = icon; }
  get icon(): string{ return this._icon }
  protected _icon: string;
  
  @Input() set action(action: Function | {function: Function, params: any[]}){ this._action = action }
  protected _action: Function | {function: Function, params: any[]} = ()=>console.log(`click on ${this.label}`);

  @Input() disabled: boolean = false;

  @Input() preventFocus: false;
  @Input() menuOptions: any[];
  @Input() type: 'icon' | 'raised' = 'raised'

  @Input() set settings(_settings: Stylable){
    this._initSettings(_settings)
  }
  get settings(){
    return this._settings;
  }
  _settings: Stylable

  protected _preventMultipleActionExecutions;

  constructor(protected _injector: Injector) {
    this._initSettings();
  }

  public async doAction(){
    if (!this._preventMultipleActionExecutions) {
      this._preventMultipleActionExecutions = true;
      await this._action.hasOwnProperty('params') 
            ? this._action['function'](...this._action['params']) 
            : (this._action as Function)();
      setTimeout(async () => {
        this._preventMultipleActionExecutions = false;
      }, 1000);
    }
  }

  public async doMenuAction(menuOption){
    if (!this._preventMultipleActionExecutions) {
      this._preventMultipleActionExecutions = true;
      await menuOption.action();
      setTimeout(async () => {
        this._preventMultipleActionExecutions = false;
      }, 1000);
    }
  }

  private _initSettings(settings?: Stylable){
    const _settings = JSON.parse(JSON.stringify(settings||{}))

    _settings.padding = _settings.padding || '0 10px';

    // _settings.hoverTileSettings = _settings.hoverTileSettings || JSON.parse(JSON.stringify(_settings.tileSettings))
    // _settings.selectedTileSettings = _settings.hoverTileSettings || JSON.parse(JSON.stringify(_settings.tileSettings))
    
    this._settings = _settings
  }
}
